<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-totem-modal-list">
            <h2>Deseja executar o Refresh Full?</h2>
         </div>
         
         <div class="body-modal-list">
            Você realmente deseja executar o Refresh Full? Essa ação causará indisponibilidade temporaria na visualização do relatório.
         </div>
         <div class="footer-modal-list">
            <button mat-button class="btn-primary block" (click)="clickRefresh()">
                <span *ngIf="isLoading == false">Refresh</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>